// lib/dateHelpers.ts
export function getCurrentWeekNumber(date: Date = new Date()): number {
    const startOfYear = new Date(date.getFullYear(), 0, 1);
    const diffDays = Math.floor((date.getTime() - startOfYear.getTime()) / 86400000);
    return Math.ceil((diffDays + startOfYear.getDay() + 1) / 7);
}

export function getCurrentMonthNumber(date: Date = new Date()): number {
    return date.getMonth() + 1;
}